// En-tête de page + surface de contenu. La navigation est fournie par AppShell.
// Bouton « Retour » : revient à la page précédente de l'application (absent si la page a été ouverte directement).
import React, { useEffect } from 'react';
import { Box, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const Layout = ({ children, title, actions, plain = false, back = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // « default » : première page de la session (lien direct, rechargement) — pas d'historique interne
  const peutRevenir = back && location.key !== 'default';
  useEffect(() => {
    if (title) document.title = `${title} — DOCC`;
  }, [title]);

  return (
    <Box>
      {(title || actions) && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 2 }}>
          {title && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: '1 1 220px', minWidth: 0 }}>
              {peutRevenir && (
                <Tooltip title="Retour">
                  <IconButton className="no-print" onClick={() => navigate(-1)} aria-label="Retour à la page précédente"
                    sx={{ ml: -1, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', '@media print': { display: 'none' } }}>
                    <ArrowBack fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              <Typography variant="h4" component="h1" sx={{ minWidth: 0 }}>{title}</Typography>
            </Box>
          )}
          {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>{actions}</Box>}
        </Box>
      )}
      {plain ? children : (
        <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 } }}>
          {children}
        </Paper>
      )}
    </Box>
  );
};

export default Layout;
